import React, { ReactNode } from 'react';

type TemplateProps = {
  id: string;
  backgroundColor?: string;
  children: ReactNode;
};

const PageTemplate = ({ id, backgroundColor, children }: TemplateProps) => {
  return (
    <section
      id={id}
      className='box-border pt-16 md:pt-20 bg-black overflow-x-hidden flex flex-col md:justify-center items-center relative w-full'
    >
      {children}
    </section>
  );
};

export default PageTemplate;

export const PageLayout = ({ children, className = '', ...props }) => (
  <section
    className={`relative w-[73.125rem] min-w-[700px] h-[43.75rem] box-border px-12 mx-auto gap-12 flex justify-center items-center max-[700px]:aspect-[11/7] max-[700px]:p-8 max-[700px]:m-0 ${className}`}
    {...props}
  >
    {children}
  </section>
);

export const TitleWrapper = ({ children, className = '', ...props }) => (
  <section
    className={`w-full flex justify-center items-center gap-4 ${className}`}
    {...props}
  >
    {children}
  </section>
);

export const Title = ({ children, className = '', ...props }) => (
  <h1
    className={`w-full m-0 text-[2.2rem] font-light text-white text-justify ${className}`}
    {...props}
  >
    {children}
  </h1>
);

export const Emphasize = ({ children, className = '', ...props }) => (
  <span className={`text-[#fccb16] inline ${className}`} {...props}>
    {children}
  </span>
);

export const Content = ({ children, className = '', ...props }) => (
  <main className={`w-full flex justify-between ${className}`} {...props}>
    {children}
  </main>
);
